import Vue from 'vue';
import axios from 'axios';
import CONFIG from '../config';
import { errors } from '../constants/commonContent';

const COUNTER = 3;
const DELAY = 2000;

function isIpfsHash(hash) {
  if (hash) {
    return hash.toString().startsWith('Qm') ? true : false;
  }
}

// TODO: change double code
export default function ipfs(address, memberKey) {
  return {
    getAuthHeader() {
      return {
        headers: {
          'X-Address': address,
          'X-Token': memberKey,
          'X-Master-Address': CONFIG.masterAddress
        }
      };
    },
    async get(multihash) {
      const authHeader = this.getAuthHeader();
      if (isIpfsHash(multihash)) {
        return await new Promise((resolve, reject) => {
          let url = CONFIG.backendURL + CONFIG.endPoints.ipfsGet + '/' + multihash;

          let count = COUNTER;
          getFile();

          function getFile() {
            axios.get(url, authHeader).then(
              response => {
                if (
                  response.status === errors.backend.status.ipfsDown.statusCode &&
                  response.statusText === errors.backend.status.ipfsDown.statusText
                ) {
                  if (--count) {
                    setTimeout(getFile, DELAY);
                  } else {
                    Vue.toasted.error(errors.backend.status.ipfsDown.infoText);
                    reject(new Error());
                  }
                } else {
                  resolve(response.data);
                }
              },
              error => {
                if (--count) {
                  setTimeout(getFile, DELAY);
                } else {
                  Vue.toasted.error(errors.backend.status.serverDown.infoText);
                  reject(new Error(error));
                }
              }
            );
          }
        });
      }
    },
    async getFileByXHR(multihash) {
      if (isIpfsHash(multihash)) {
        const authHeader = this.getAuthHeader();
        return await new Promise((resolve, reject) => {
          let url = CONFIG.backendURL + CONFIG.endPoints.ipfsGet + '/' + multihash;

          let count = COUNTER;
          getFile();

          function getFile() {
            const oReq = new XMLHttpRequest();

            oReq.open('GET', url, true);
            oReq.responseType = 'blob';
            Object.keys(authHeader.headers).forEach(key => {
              oReq.setRequestHeader(key, authHeader.headers[key]);
            });

            oReq.onload = () => {
              const blob = oReq.response;
              if (
                oReq.status === errors.backend.status.ipfsDown.statusCode &&
                oReq.statusText === errors.backend.status.ipfsDown.statusText
              ) {
                if (--count) {
                  setTimeout(getFile, DELAY);
                } else {
                  Vue.toasted.error(errors.backend.status.ipfsDown.infoText);
                  reject(new Error());
                }
              } else {
                resolve(blob);
              }
            };
            oReq.onerror = error => {
              if (--count) {
                setTimeout(getFile, DELAY);
              } else {
                Vue.toasted.error(errors.backend.status.ipfsDown.infoText);
                reject(new Error((<any>error).message));
              }
            };

            oReq.send();
          }
        });
      }
    },
    async add(data) {
      const authHeader = this.getAuthHeader();
      return await new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append('file', data.file);
        let url = CONFIG.backendURL + CONFIG.endPoints.ipfsAdd;

        let count = COUNTER;
        addFile();

        function addFile() {
          axios.post(url, formData, authHeader).then(
            response => {
              if (
                response.status === errors.backend.status.ipfsDown.statusCode &&
                response.statusText === errors.backend.status.ipfsDown.statusText
              ) {
                if (--count) {
                  setTimeout(addFile, DELAY);
                } else {
                  Vue.toasted.error(errors.backend.status.ipfsDown.infoText);
                  reject(new Error());
                }
              } else {
                resolve(response.data[0].hash);
              }
            },
            error => {
              if (--count) {
                setTimeout(addFile, DELAY);
              } else {
                Vue.toasted.error(errors.backend.status.serverDown.infoText);
                reject(new Error(error));
              }
            }
          );
        }
      });
    }
  };
}
